import type { CirclePaint, SymbolLayout, SymbolPaint } from 'mapbox-gl';

// Standard v3 dark basemaps apply ambient lighting to GL layer paint colors unless a layer
// opts out via `*-emissive-strength: 1`; without it, these render dimmed/tinted in dark mode.
export const FIELD_NOTES_CIRCLE_EMISSIVE_PAINT: CirclePaint = {
  'circle-emissive-strength': 1,
};

export const DIRECTION_CONES_LAYOUT: SymbolLayout = {
  'icon-image': ['case', ['get', 'isHovered'], 'directionConeHover', 'directionCone'],
  'icon-rotate': ['get', 'compassHeading'],
  'icon-rotation-alignment': 'map',
  'icon-anchor': 'bottom',
  'icon-allow-overlap': true,
  'icon-size': ['interpolate', ['linear'], ['zoom'], 10, 0.15, 22, 1.0],
};

export const DIRECTION_CONES_PAINT: SymbolPaint = {
  'icon-emissive-strength': 1,
};
